import chapterReducer from '../chapter/chapter.reducer';
import teacherReducer from '../teacher/teacher.reducer';
import * as moment from 'moment-jalaali';

function save(sess, courseObj) {
    const {Course} = sess;
    if (Course.idExists(courseObj.id)) {
        Course.withId(courseObj.id).teachers.all().delete();
    }
    let teachers = null;
    if (courseObj.teachers) {
        teachers = courseObj.teachers.map((teacherObj, index) => {
            return teacherReducer.save(sess, teacherObj);
        });
    }
    let courseObj2 = Object.assign({}, courseObj);
    delete courseObj2.chapters;
    return Course.create({
        ...courseObj2,
        teachers
    });
}

function remove(sess, id) {
    const {Course} = sess;
    if (!Course.idExists(id)) {
        throw new Error(`can not find course with id '${id}'`);
    }
    Course.withId(id).chapters.toRefArray().forEach((c) => {
        chapterReducer.remove(sess, c.id);
    });
    Course.withId(id).teachers.toRefArray().forEach((c) => {
        teacherReducer.remove(sess, c.id);
    });
    return Course.withId(id).delete();
}

function addChapter(sess, chapter, courseId) {
    const {Course} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }
    if (!chapter) {
        throw new Error(`chapter is required`);
    }
    const chapterModel = chapterReducer.save(sess, chapter);
    return Course.withId(courseId).chapters.add(chapterModel);
}

function removeChapter(sess, chapterId, courseId) {
    const {Course, Chapter} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }
    if (!Chapter.idExists(chapterId)) {
        throw new Error(`can not find chapter with id '${chapterId}'`);
    }
    return Course.withId(courseId).chapters.remove(chapterId);
}

function updateProgress(sess, courseId, lockedUnitsCount, seenUnitsCount, totalUnitsCount) {
    const {Course} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }
    const targetCourse = Course.withId(courseId);
    targetCourse.update({
        lockedUnitsCount: lockedUnitsCount,
        seenUnitsCount: seenUnitsCount,
        totalUnitsCount: totalUnitsCount,
    });
    return targetCourse;
}

function updateParticipationRate(sess, courseId, participationRate) {
    const {Course} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }
    const targetCourse = Course.withId(courseId);
    targetCourse.update({
        participationRate: participationRate,
    });
}

function updateBreadcrumb(sess, items) {
    const { CourseBreadcrumb } = sess;
    CourseBreadcrumb.all().delete();
    const results = items.map((item) => {
        return CourseBreadcrumb.create({
            title: item.title,
            link: item.link,
            order: item.order
        })
    });
    return results;
}

function updateFinalScores(sess, courseId, date, score) {
    const {Course} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }
    Course.withId(courseId).update({
        totalScore: score,
        reportFinalScoreDate: date ? moment(date) : null,
    })
}

function addFinalScoresFactor(sess, courseId, key, coefficient, totalScore, score) {
    const {Course, ScoresFactors} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }
    
    const ScoresFactorsModel = ScoresFactors.create({
        key: key,
        coefficient: coefficient,
        totalScore: totalScore,
        score: score,
    })
    
    Course.withId(courseId).scoresFactors.add(ScoresFactorsModel);
}

function removeFinalScoresFactor(sess, courseId, key) {
    const {Course} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }
    Course.withId(courseId).scoresFactors.filter({
        key: key,
    }).delete();
}

function cleanAllScoresFactor(sess, courseId) {
    const {Course} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }

    Course.withId(courseId).scoresFactors.all().delete();
}

function setPeriods(sess, courseId, periods) {
    const {Course, Period} = sess;
    if (!Course.idExists(courseId)) {
        throw new Error(`can not find course with id '${courseId}'`);
    }

    periods.forEach(p => {
        const periodInstance = Period.create(p);
        Course.withId(courseId).periods.add(periodInstance);
    })
}

export default {
    save,
    remove,
    addChapter,
    removeChapter,
    updateProgress,
    updateParticipationRate,
    updateBreadcrumb,
    updateFinalScores,
    addFinalScoresFactor,
    removeFinalScoresFactor,
    cleanAllScoresFactor,
    setPeriods,
};